export const UCT_QUESTIONS = [
  {
    key: 'sintomas_fisicos',
    name: 'Quanto você sofreu com os sintomas físicos da urticária (coceira, empolação e/ou inchaço) nas últimas 4 semanas?',
  },
  {
    key: 'qualidade_vida',
    name: 'Quanto a sua qualidade de vida foi afetada negativamente por causa da urticária nas últimas 4 semanas?',
  },
  {
    key: 'tratamento_insuficiente',
    name: 'Com que frequência o seu tratamento para urticária não foi suficiente para controlar os sintomas da urticária nas últimas 4 semanas?',
  },
  {
    key: 'sob_controle',
    name: 'De maneira geral, quanto você conseguiu ter a sua urticária sob controle nas últimas 4 semanas?',
  },
]
export const UCT_OPTIONS = [
  {
    text: 'Nada',
    value: 0,
  },
  {
    text: 'Pouco',
    value: 1,
  },
  {
    text: 'Mais ou Menos',
    value: 2,
  },
  {
    text: 'Muito',
    value: 3,
  },
  {
    text: 'Bastante',
    value: 4,
  },
]
